import { KCP_INFO_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import { KCPInfoItem } from '../type/kcpIngestType';

class KcpInfoService extends ApiService<KCPInfoItem> {
  constructor() {
    super(KCP_INFO_API_PATH);
  }

  // Fetch list
  public async fetch(queryParams?: URLSearchParams): Promise<FetchResult<KCPInfoItem>> {
    return super.fetch(queryParams);
  }
}

export const kcpInfoService = new KcpInfoService();



